import { useShowKanban } from "contexts/showkanban-context";
import React from "react";
import { NavLink } from "react-router-dom";

const ToggleKanban = ({ title, linkTable = "/", linkKanban = "/" }) => {
	const { showKanban ,setShowKanban } = useShowKanban();
	return (
		<>
			<div className='flex gap-30px'>
				<h2 className='title-primary'>{title}</h2>
				<div className='flex gap-10px'>
					<div
						className={`theme-toggle-item ${
							showKanban || "active"
						}`}
						onClick={() => setShowKanban(false)}>
						<em className='fa-light fa-table'></em>
					</div>
					<div
						className={`theme-toggle-item ${
							!showKanban || "active"
						}`}
						onClick={() => setShowKanban(true)}>
						<em className='fa-light fa-objects-column'></em>
					</div>
				</div>
			</div>
		</>
	);
};

export default ToggleKanban;
